import { ConversationFactory } from 'src/modules/conversations/factories';
import { formatMessageToSend } from 'src/modules/conversations/helpers/formatMessageToSend';
import {
    TActionStrategy,
    TReplyWhatsappDraft,
} from 'src/modules/assistant/actions/types';
import { IStore } from 'src/interfaces/store';
import { IConversation } from 'src/interfaces/conversation';

/**
 * Legacy areas: formats the message for the area provider and sends it through
 * `DpxConversationsState` (`/dpxConversations/sendMessage`).
 */
export const sendLegacyReply: TActionStrategy<TReplyWhatsappDraft> = async (
    draft,
    { lead, user, conversationActions }
) => {
    const conversation = ConversationFactory.createFromConversation({
        ...lead.conversation,
        store: lead.store as IStore,
    });
    const formatted = formatMessageToSend({
        message: draft.message,
        attachments: draft.attachments || [],
        documentation: [],
        // formatMessageToSend only reads fields present on the built conversation
        conversation: conversation as unknown as IConversation,
        user,
    });
    if (formatted.error) return false;
    return conversationActions.sendMessage(
        { ...formatted.data, isAssistantGenerated: true },
        formatted.sendType
    );
};
